import React from "react";
import Header from "../../components/header/header";
import HeroCarousel from "../../components/carousel/carousel";
import WhatWeDo from "../../components/services/services";
import Demo from "../../components/demo/demo";

const Home = () => {
  return (
    <div>
      {/* Header */}
      <Header />

      <Demo />

      {/* <HeroCarousel /> */}
      {/* <HeroCarousel /> */}

      {/* <WhatWeDo /> */}
      <WhatWeDo />
    </div>
  );
};

export default Home;
